import _regeneratorRuntime from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.push.js";
import { setUserID, removeUserID, setToken, removeToken, getToken } from '@/utils/auth';
import { setCookie, getCookie, removeCookie } from '@/utils/cookie-helper';
import { getLocalFileURL } from '@/utils/various';
import i18n, { available_locales } from '@/lang';
import Login from './auth/login';
import Verify from './auth/verify';
import Player from './player/index';
import 'webostvjs/webOSTV';
import { Capacitor } from '@capacitor/core';
import { Media } from 'capacitor-media';
import { App } from '@capacitor/app';
import { ScreenBrightness } from '@capacitor-community/screen-brightness';
import { KeepAwake } from '@capacitor-community/keep-awake';
import { SplashScreen } from '@capacitor/splash-screen';
import { isConnected, connect, disconnect } from '@/utils/socketio';
import { getDevid } from '@/utils/various';
import request from '@/utils/request';
import Hammer from 'hammerjs';

// ---- Outsource
// https://capacitorjs.com/docs/android/custom-code
import { registerPlugin } from '@capacitor/core';
var HDMIAudio;
if (Capacitor.isPluginAvailable('HDMIAudio')) HDMIAudio = registerPlugin('HDMIAudio');else HDMIAudio = undefined;
// ----

export default {
  name: 'App',
  components: {
    Login: Login,
    Verify: Verify,
    Player: Player
  },
  data: function data() {
    return {
      reload_css: 0,
      play_local: false,
      // App was opened to play a local media
      can_play_offline: false,
      // Server is unreachable but we have some data in cache which we can play (schedule, playlists and medias)
      registration_data: undefined,
      verification_data: undefined,
      connected: isConnected() // Sometimes socketio is connected faster than vue component is initialized => get initial value
    };
  },

  sockets: {
    connect: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this = this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.reload_css++;
              this.connected = true;
              this.$nextTick( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      if (!_this.$refs.player) {
                        _context.next = 4;
                        break;
                      }
                      _context.next = 3;
                      return _this.$refs.player.canPlayOffline();
                    case 3:
                      _this.can_play_offline = _context.sent;
                    case 4:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              })));
              this.$forceUpdate();

              // if connection was interrupted => request data
              _context2.next = 6;
              return this.sendReady();
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function connect() {
        return _connect.apply(this, arguments);
      }
      return connect;
    }(),
    disconnect: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.connected = false;
              this.readySent = undefined;
              _context3.next = 4;
              return this.$refs.player.canPlayOffline();
            case 4:
              this.can_play_offline = _context3.sent;
              this.$forceUpdate();
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function disconnect() {
        return _disconnect.apply(this, arguments);
      }
      return disconnect;
    }()
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
      var intro_media;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            Media.getAlbums().then(function (albums) {}).catch(function (e) {}); // Permission request shall be asked before scanning QR

            // --- Check if Intro was already played, if not play it
            if (!(!getCookie('intro_played') && !_this2.isLoggedIn())) {
              _context10.next = 12;
              break;
            }
            _context10.prev = 2;
            _context10.next = 5;
            return request({
              url: '/medias/intro',
              method: 'GET',
              silent: true
            });
          case 5:
            intro_media = _context10.sent;
            if (intro_media) {
              _this2.play_local = true;
              _this2.$nextTick( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                var result;
                return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.prev = 0;
                      _context4.next = 3;
                      return _this2.$refs.player.interrupt(intro_media, {
                        controls: false,
                        branding: false
                      });
                    case 3:
                      result = _context4.sent;
                      if (!(result.success || result.next || result.prev)) {
                        _context4.next = 8;
                        break;
                      }
                      setCookie('intro_played', Date.now());
                      _context4.next = 12;
                      break;
                    case 8:
                      if (!result.err) {
                        _context4.next = 12;
                        break;
                      }
                      _context4.next = 11;
                      return _this2.sendReady(true);
                    case 11:
                      console.error("Failed playing intro: ", result.err);
                    case 12:
                      _context4.next = 19;
                      break;
                    case 14:
                      _context4.prev = 14;
                      _context4.t0 = _context4["catch"](0);
                      _context4.next = 18;
                      return _this2.sendReady(true);
                    case 18:
                      console.error("Failed playing intro: ", _context4.t0);
                    case 19:
                      _this2.play_local = false;
                      if (!_this2.send_ready_when_done) {
                        _context4.next = 25;
                        break;
                      }
                      _context4.next = 23;
                      return _this2.sendReady();
                    case 23:
                      _context4.next = 26;
                      break;
                    case 25:
                      if (_this2.isLoggedIn()) _this2.$refs.player.seekCurrentSchedulePosition();
                    case 26:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4, null, [[0, 14]]);
              })));
            }
            _context10.next = 12;
            break;
          case 9:
            _context10.prev = 9;
            _context10.t0 = _context10["catch"](2);
            console.error("Failed loading intro", _context10.t0);
          case 12:
            // --- Play local file
            if (Capacitor.isPluginAvailable('App')) {
              App.addListener('appUrlOpen', /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(urlOpen) {
                  var url;
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        url = urlOpen.url;
                        console.log(url);
                        if (url.startsWith('file://') || url.startsWith('content://')) {
                          url = getLocalFileURL(url);
                          _this2.play_local = true;
                          _this2.$nextTick( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
                            return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                              while (1) switch (_context5.prev = _context5.next) {
                                case 0:
                                  if (!url) {
                                    _context5.next = 4;
                                    break;
                                  }
                                  _context5.next = 3;
                                  return _this2.$refs.player.interrupt({
                                    url: url,
                                    caching: false,
                                    duration: -1
                                  }, {
                                    controls: true,
                                    branding: false
                                  });
                                case 3:
                                  _this2.play_local = false;
                                case 4:
                                  if (!_this2.send_ready_when_done) {
                                    _context5.next = 9;
                                    break;
                                  }
                                  _context5.next = 7;
                                  return _this2.sendReady();
                                case 7:
                                  _context5.next = 10;
                                  break;
                                case 9:
                                  if (_this2.isLoggedIn()) _this2.$refs.player.seekCurrentSchedulePosition();
                                case 10:
                                case "end":
                                  return _context5.stop();
                              }
                            }, _callee5);
                          })));
                        }
                      case 3:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }());
            }
            if (!_this2.intentListener) {
              _this2.intentListener = /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(e) {
                  var i, clip, url, content_type;
                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        i = 0;
                      case 1:
                        if (!(i < e.clip_data.length)) {
                          _context7.next = 11;
                          break;
                        }
                        clip = e.clip_data[i];
                        if (clip.uri) {
                          content_type = clip.content_type.startsWith("image") || clip.content_type.startsWith("video") ? clip.content_type : undefined; // guess
                          console.log(url);
                          url = clip.uri;
                          url = getLocalFileURL(url);
                          _this2.play_local = true;
                        }
                        if (!url) {
                          _context7.next = 8;
                          break;
                        }
                        _context7.next = 7;
                        return _this2.$refs.player.interrupt({
                          url: url,
                          content_type: content_type,
                          caching: false,
                          duration: -1
                        }, {
                          controls: true,
                          branding: false
                        });
                      case 7:
                        _this2.play_local = false;
                      case 8:
                        i++;
                        _context7.next = 1;
                        break;
                      case 11:
                        if (!_this2.send_ready_when_done) {
                          _context7.next = 16;
                          break;
                        }
                        _context7.next = 14;
                        return _this2.sendReady();
                      case 14:
                        _context7.next = 17;
                        break;
                      case 16:
                        if (_this2.isLoggedIn()) _this2.$refs.player.seekCurrentSchedulePosition();
                      case 17:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function (_x2) {
                  return _ref5.apply(this, arguments);
                };
              }();
            }
            document.addEventListener('intent', _this2.intentListener);
            // ---

            if (_this2.sockets) {
              _this2.sockets.subscribe('registration_code', function (data) {
                _this2.registration_data = data;
              });
              _this2.sockets.subscribe('start_verification', function (data) {
                if (_this2.$refs.player) {
                  _this2.$refs.player.clearMediaTimeout({
                    comment: 'Verification started',
                    stop_video: true
                  });
                  _this2.$refs.player.show(); // hide all elements
                }

                _this2.verification_data = data;
              });
              _this2.sockets.subscribe('stop_verification', function (data) {
                _this2.verification_data = undefined;
                _this2.$nextTick(function () {
                  if (_this2.$refs.player) {
                    _this2.$refs.player.seekCurrentSchedulePosition();
                  }
                });
              });
              _this2.sockets.subscribe('reload_styles', function (data) {
                _this2.reload_css++;
                _this2.$forceUpdate();
              });
              _this2.sockets.subscribe('connected', function (data) {
                setUserID(data.id);
                setToken(data.token);
                setCookie('screen_id', data.screen_id, {
                  expires: 365
                });
                _this2.$forceUpdate();
              });
              _this2.sockets.subscribe('disconnected', /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(data) {
                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        if (!_this2.$refs.player) {
                          _context8.next = 7;
                          break;
                        }
                        _this2.$refs.player.clearMediaTimeout({
                          comment: 'Screen disconnected',
                          stop_video: true,
                          callback_caller_args: {
                            success: false,
                            end_loop: true
                          }
                        });
                        _context8.next = 4;
                        return _this2.$refs.player.show();
                      case 4:
                        _context8.next = 6;
                        return _this2.$refs.player.clearCache();
                      case 6:
                        _this2.$refs.player.setSchedule(null, true);
                      case 7:
                        _this2.readySent = undefined;
                        removeUserID();
                        removeToken();
                        removeCookie('screen_id');
                        _this2.$forceUpdate();
                      case 12:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8);
                }));
                return function (_x3) {
                  return _ref6.apply(this, arguments);
                };
              }());
              _this2.sockets.subscribe('clear_cache', function (data) {
                if (_this2.$refs.player) _this2.$refs.player.clearCache();
              });
              _this2.sockets.subscribe('setLanguage', function (data) {
                if (data && available_locales.includes(data.langcode) && data.langcode != i18n.locale) {
                  i18n.locale = data.langcode;
                  _this2.$router.push({
                    path: '/' + data.langcode
                  });
                }
              });
              // Putting interrupt event here so we can also send content to a non logged in screen
              _this2.sockets.subscribe('interrupt', function (data) {
                if (_this2.$refs.player) {
                  _this2.play_local = true;
                  _this2.$nextTick( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
                    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                      while (1) switch (_context9.prev = _context9.next) {
                        case 0:
                          _context9.next = 2;
                          return _this2.$refs.player.interrupt(data);
                        case 2:
                          _this2.play_local = false;
                        case 3:
                        case "end":
                          return _context9.stop();
                      }
                    }, _callee9);
                  })));
                }
              });
            }
          case 16:
          case "end":
            return _context10.stop();
        }
      }, _callee10, null, [[2, 9]]);
    }))();
  },
  destroyed: function destroyed() {
    if (this.intentListener) document.removeEventListener('intent', this.intentListener);
    this.sockets.unsubscribe('registration_code');
    this.sockets.unsubscribe('start_verification');
    this.sockets.unsubscribe('stop_verification');
    this.sockets.unsubscribe('connected');
    this.sockets.unsubscribe('disconnected');
    this.sockets.unsubscribe('clear_cache');
    this.sockets.unsubscribe('setLanguage');
    this.sockets.unsubscribe('interrupt');
    this.readySent = undefined;
  },
  mounted: function mounted() {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            if (!HDMIAudio) {
              _context11.next = 4;
              break;
            }
            _context11.next = 3;
            return HDMIAudio.addListener("ACTION_HDMI_AUDIO_PLUG", function (e) {
              //console.log("ACTION_HDMI_AUDIO_PLUG listener called")
              //console.log(e)
              if (e.EXTRA_AUDIO_PLUG_STATE == 0) _this3.pause();
              if (e.EXTRA_AUDIO_PLUG_STATE == 1) _this3.resume();
            });
          case 3:
            _this3.hdmiAudioListener = _context11.sent;
          case 4:
            _context11.next = 6;
            return App.addListener("appStateChange", function (e) {
              if (!e.isActive) {
                _this3.pause();
              } else {
                _this3.resume();
              }
            });
          case 6:
            _this3.appStateChangeListener = _context11.sent;
            _context11.next = 9;
            return _this3.initScreen();
          case 9:
            _context11.next = 11;
            return _this3.initKeyControls();
          case 11:
            _context11.next = 13;
            return _this3.sendReady();
          case 13:
            _context11.next = 15;
            return _this3.$refs.player.canPlayOffline();
          case 15:
            _this3.can_play_offline = _context11.sent;
            _this3.$forceUpdate();
            _context11.next = 19;
            return SplashScreen.hide({
              fadeOutDuration: 500
            });
          case 19:
            _this3.$nextTick(function () {
              if (_this3.can_play_offline && !_this3.connected) _this3.$refs.player.seekCurrentSchedulePosition();
            });
          case 20:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            // --- Unregister
            // https://capacitor.ionicframework.com/docs/apis/app/
            if (_this4.appStateChangeListener) {
              _this4.appStateChangeListener.remove();
            }
            if (_this4.hdmiAudioListener) _this4.hdmiAudioListener.remove();
            _context12.next = 4;
            return _this4.destroyScreen();
          case 4:
            _this4.destroyKeyControls();
          case 5:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }))();
  },
  methods: {
    getBaseURL: function getBaseURL() {
      return process.env.VUE_APP_BASE_API;
    },
    pause: function pause() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              console.log("Pause called");
              if (_this5.$refs.player) _this5.$refs.player.pause();
              _context13.next = 4;
              return _this5.destroyScreen();
            case 4:
              disconnect();
              _this5.readySent = undefined;
            case 6:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    resume: function resume() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              console.log("Resume called");
              connect();
              _context14.next = 4;
              return _this6.sendReady();
            case 4:
              _this6.initScreen();
              if (_this6.$refs.player) _this6.$refs.player.resume();
            case 6:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    // ---
    initScreen: function initScreen() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var currentBrightness;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;
              _context15.next = 3;
              return ScreenBrightness.getBrightness();
            case 3:
              currentBrightness = _context15.sent;
              _this7.initial_brightness = currentBrightness.brightness;
              console.log('Initial brightness: ' + currentBrightness.brightness);

              //await ScreenBrightness.setBrightness({brightness: 1})
              _context15.next = 11;
              break;
            case 8:
              _context15.prev = 8;
              _context15.t0 = _context15["catch"](0);
              console.log('Couldn\'t read display brightness: ' + _context15.t0);
            case 11:
              KeepAwake.keepAwake().catch(function (e) {});
            case 12:
            case "end":
              return _context15.stop();
          }
        }, _callee15, null, [[0, 8]]);
      }))();
    },
    destroyScreen: function destroyScreen() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              KeepAwake.allowSleep().catch(function (e) {});
              if (_this8.initial_brightness !== undefined && _this8.initial_brightness !== null) {
                console.log('AdFlow: Setting brightness to ' + _this8.initial_brightness);
                //await ScreenBrightness.setBrightness({brightness: this.initial_brightness})
              }
            case 2:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    },
    initKeyControls: function initKeyControls() {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var onBackbutton;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              // --- Back button
              onBackbutton = /*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
                  return _regeneratorRuntime().wrap(function _callee17$(_context17) {
                    while (1) switch (_context17.prev = _context17.next) {
                      case 0:
                        _context17.prev = 0;
                        _context17.next = 3;
                        return App.exitApp();
                      case 3:
                        _context17.next = 7;
                        break;
                      case 5:
                        _context17.prev = 5;
                        _context17.t0 = _context17["catch"](0);
                      case 7:
                        try {
                          window.tizen.application.getCurrentApplication().exit();
                        } catch (e) {}
                        try {
                          webOS.platformBack();
                        } catch (e) {}
                        _this9.$destroy(); // Without this line destroyed hook will not be called
                        window.close();
                      case 11:
                      case "end":
                        return _context17.stop();
                    }
                  }, _callee17, null, [[0, 5]]);
                }));
                return function onBackbutton() {
                  return _ref8.apply(this, arguments);
                };
              }(); //  Android
              _context19.next = 3;
              return App.addListener('backButton', function (e) {
                onBackbutton();
              });
            case 3:
              _this9.backbuttonListener = _context19.sent;
              // Samsung TV
              _this9.tizenhwkey = function (e) {
                // Keycodes: https://developer.samsung.com/SmartTV/develop/guides/user-interaction/remote-control.html
                console.log("tizen: key pressed: " + e.keyName);
                if (e.keyName == "back") {
                  onBackbutton();
                }
                // --- Does not react in Emulator => keydownListener is reacting (correctly) instead
                if (_this9.$refs.player) {
                  if (e.keyName == "ArrowLeft") {
                    if (_this9.$refs.player.onPrev) _this9.$refs.player.onPrev();
                  }
                  if (e.keyName == "ArrowRight") {
                    if (_this9.$refs.player.onNext) _this9.$refs.player.onNext();
                  }
                  if (e.keyName == "MediaPlayPause") {
                    _this9.$refs.player.toggleVideo();
                  }
                }
                // ---
              };

              _this9.hammer = new Hammer(document);
              _this9.hammer.on('swipeleft', function () {
                if (_this9.$refs.player && _this9.$refs.player.onNext) _this9.$refs.player.onNext();
              });
              _this9.hammer.on('swiperight', function () {
                if (_this9.$refs.player && _this9.$refs.player.onPrev) _this9.$refs.player.onPrev();
              });
              _this9.hammer.on('tap', function () {
                if (_this9.$refs.player && _this9.$refs.player.toggleVideo) _this9.$refs.player.toggleVideo();
              });
              window.addEventListener('tizenhwkey', _this9.tizenhwkey);
              // LG Remote control
              _this9.keydownListener = /*#__PURE__*/function () {
                var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(inEvent) {
                  var keycode, preview;
                  return _regeneratorRuntime().wrap(function _callee18$(_context18) {
                    while (1) switch (_context18.prev = _context18.next) {
                      case 0:
                        // See http://webostv.developer.lge.com/develop/code-samples/remote-control/

                        if (window.event) {
                          keycode = inEvent.keyCode;
                        } else if (inEvent.which) {
                          keycode = inEvent.which;
                        }
                        if (!_this9.$refs.player) {
                          _context18.next = 25;
                          break;
                        }
                        _context18.t0 = keycode;
                        _context18.next = _context18.t0 === 80 ? 5 : _context18.t0 === 227 ? 8 : _context18.t0 === 0x25 ? 10 : _context18.t0 === 228 ? 12 : _context18.t0 === 0x27 ? 14 : _context18.t0 === 415 ? 16 : _context18.t0 === 461 ? 19 : _context18.t0 === 19 ? 21 : _context18.t0 === 179 ? 23 : _context18.t0 === 13 ? 23 : _context18.t0 === 32 ? 23 : 25;
                        break;
                      case 5:
                        // 'p'
                        preview = _this9.$refs.player.getPreview();
                        console.log(preview);
                        return _context18.abrupt("break", 25);
                      case 8:
                        // Rewind (FireTV)
                        if (_this9.$refs.player.rewind) _this9.$refs.player.rewind();
                        return _context18.abrupt("break", 25);
                      case 10:
                        // Left
                        if (_this9.$refs.player.onPrev) _this9.$refs.player.onPrev();
                        return _context18.abrupt("break", 25);
                      case 12:
                        // Fast forward (FireTV)
                        if (_this9.$refs.player.fastforward) _this9.$refs.player.fastforward();
                        return _context18.abrupt("break", 25);
                      case 14:
                        // Right
                        if (_this9.$refs.player.onNext) _this9.$refs.player.onNext();
                        return _context18.abrupt("break", 25);
                      case 16:
                        _context18.next = 18;
                        return _this9.$refs.player.resumeVideo();
                      case 18:
                        return _context18.abrupt("break", 25);
                      case 19:
                        // Back button (LG Remote)
                        onBackbutton();
                        return _context18.abrupt("break", 25);
                      case 21:
                        // Pause (LG Remote and Keyboard)
                        _this9.$refs.player.pauseVideo();
                        return _context18.abrupt("break", 25);
                      case 23:
                        // Space (Keyboard)
                        _this9.$refs.player.toggleVideo();
                        return _context18.abrupt("break", 25);
                      case 25:
                      case "end":
                        return _context18.stop();
                    }
                  }, _callee18);
                }));
                return function (_x4) {
                  return _ref9.apply(this, arguments);
                };
              }();
              document.addEventListener("keydown", _this9.keydownListener);
              // ---
            case 12:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }))();
    },
    destroyKeyControls: function destroyKeyControls() {
      if (this.backbuttonListener) {
        this.backbuttonListener.remove();
      }
      if (this.tizenhwkey) {
        window.removeEventListener('tizenhwkey', this.tizenhwkey);
      }
      if (this.keydownListener) {
        document.removeEventListener('keydown', this.keydownListener);
      }
      if (this.hammer) {
        this.hammer.off('swipeleft');
        this.hammer.off('swiperight');
        this.hammer.off('tap');
      }
    },
    // ---------
    onPlayerStatusChanged: function onPlayerStatusChanged(data) {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              if (!data.update_can_play_offline) {
                _context20.next = 4;
                break;
              }
              _context20.next = 3;
              return _this10.$refs.player.canPlayOffline();
            case 3:
              _this10.can_play_offline = _context20.sent;
            case 4:
              _this10.$forceUpdate();
            case 5:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }))();
    },
    isPlayerVisible: function isPlayerVisible() {
      return !verification_data || isPlaying() || play_local || !verification_data && can_play_offline;
    },
    isVerificationVisible: function isVerificationVisible() {
      return verification_data != null && verification_data != undefined;
    },
    isLoginVisible: function isLoginVisible() {
      return !isLoggedIn() && registration_data && connected && !play_local;
    },
    isWaitingForServerVisible: function isWaitingForServerVisible() {
      return !isLoggedIn() && !play_local && (!registration_data || !connected) && !can_play_offline;
    },
    // ---------
    isPlaying: function isPlaying() {
      if (this.$refs.player) return this.$refs.player.isPlaying();
      return false;
    },
    isLoggedIn: function isLoggedIn() {
      // Let current playlist finish playing to avoid showing "Waiting for server" when server is being updated or any other short interruption
      return getToken() != null && (this.connected || this.$refs.player && this.$refs.player.inPlaylist());
    },
    sendReady: function sendReady() {
      var _arguments = arguments,
        _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var force;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              force = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
              if (!(!_this11.play_local && !_this11.readySent && getCookie('intro_played') || force)) {
                _context21.next = 13;
                break;
              }
              _this11.$refs.player.onReady(); // Tell player we have sent the ready event now (avoid cached schedule to interrupt the intro)
              _context21.t0 = _this11.$socket;
              _context21.next = 6;
              return getDevid();
            case 6:
              _context21.t1 = _context21.sent;
              _context21.t2 = {
                devid: _context21.t1
              };
              _context21.t0.emit.call(_context21.t0, 'ready', _context21.t2);
              _this11.readySent = Date.now();
              _this11.send_ready_when_done = undefined;
              _context21.next = 14;
              break;
            case 13:
              _this11.send_ready_when_done = true;
            case 14:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      }))();
    }
  }
};